<template>
	<fieldset	class="radio radio_container">
    <legend v-if="legend">
      <span v-sanitize="legend"/>
      <span
        v-if="legendOption"
        class="optional"
        v-sanitize="legendOption"
      />
    </legend>

    <div class="radio-rating">
      <div
        class="radio-rating__options"
        :class="{
          'radio-rating__options--small': optionsEnhanced.length > 10
        }"
      >
        <div
          v-for="(option, index) in optionsEnhanced"
          :key="option.value"
          class="radio-rating__option"
        >
          <input
            type="radio"
            class="radio-rating__option-input"
            :id="`${uniqueId}-${index}-${option.value}`"
            :name="name"
            :required="required"
            :value="option.value"
            @change="onChange"
            :checked="option.value === value"
            :disabled="disabled"
          >
          <label
            class="radio-rating__option-label"
            :for="`${uniqueId}-${index}-${option.value}`"
            v-sanitize="option.label"
          />
        </div>
      </div>
      <div class="radio-rating__scale">
        <div
          class="radio-rating__scale-start"
          v-sanitize="startScale"
        />
        <div
          class="radio-rating__scale-end"
          v-sanitize="endScale"
        />
      </div>
    </div>
	</fieldset>
</template>

<script>
export default {
	props: {
		name: String,
		legend: String,
		legendOption: String,
		required: Boolean,
		value: Number | String,
		options: Array,
		disabled: Boolean,
	},
	data() {
		return {
			uniqueId: `${this.name}-${(Date.now().toString(36) + Math.random().toString(36).substring(2, 7))}`,
		}
	},
  computed: {
    optionsEnhanced() {
      const min = Math.min(...this.options.map(o => o.value))
      const max = Math.max(...this.options.map(o => o.value))
      const options = []

      for (let i = min; i <= max; i++) {
        options.push({
          value: i,
          label: i,
        })
      }
      return options
    },
    startScale() {
      return this.options.at(0)?.label
    },
    endScale() {
      return this.options.at(-1)?.label
    },
  },
	methods: {
		onChange(e) {
			this.$emit('input', e.target.value);
		}
	}
}
</script>

<style>

</style>
